<template>
  <b-modal
    ref="modal-create"
    id="modal-create"
    title="Add New Employee"
    centered
    hide-footer
    hide-header
  >
    <div class="p-3">
      <b-form autocomplete="off">
        <div class="d-flex justify-content-between align-items-start mb-3">
          <h4>
            <b>{{ isEdit ? "Edit Employee" : "Create New Employee" }}</b>
          </h4>
          <img class="pointer" src="@/assets/btn-close.png" @click="close" />
        </div>
        <validation-observer ref="form" slim>
          <b-form-group label="" label-size="sm" label-class="font-weight-bold">
            <b-form-checkbox
              v-model="form.is_contractor"
              name="checkbox-1"
              @change="check($event)"
            >
              Is Contractor?
            </b-form-checkbox>
          </b-form-group>
          <validation-provider
            name="Username"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill"
          >
            <b-form-group
              label="Username"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-input
                autocapitalize="off"
                autocomplete="off"
                v-model="form.username"
                placeholder="Enter username"
                @change="checkUser"
                :disabled="!isNewEmployee"
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
          <label
            v-show="error !== '' || error !== null"
            style="color: red;"
            >{{ error }}</label
          >
          <validation-provider
            name="Employee Name"
            :rules="form.is_contractor ? 'required' : ''"
            v-slot="{ errors }"
            slim
            class="flex-fill"
          >
            <b-form-group
              label="Employee Name"
              label-size="sm"
              :invalid-feedback="errors[0]"
              label-class="font-weight-bold"
            >
              <b-form-input
                autocapitalize="off"
                autocomplete="off"
                v-model="form.fullname"
                placeholder="Enter employee name"
                :disabled="!form.is_contractor && trigger"
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
          <validation-provider
            name="Role"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill"
          >
            <b-form-group
              label="Role"
              label-size="sm"
              :invalid-feedback="errors[0]"
              label-class="font-weight-bold"
            >
              <b-form-select
                v-model="form.role_id"
                :options="roles"
                value-field="id"
                text-field="name"
                :class="{ 'is-invalid': errors.length }"
                size="sm"
              >
                <template #first>
                  <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </validation-provider>
          <validation-provider
            name="Division"
            v-slot="{ errors }"
            slim
            class="flex-fill"
          >
            <b-form-group
              label="Division"
              :invalid-feedback="errors[0]"
              label-size="sm"
              label-class="font-weight-bold"
            >
              <b-form-input
                autocapitalize="off"
                autocomplete="off"
                v-model="division.name"
                list="list-division"
                placeholder="Enter division"
                @keydown="onkeydown($event)"
                :class="{ 'is-invalid': errors.length }"
                :disabled="!trigger"
                @change="divisionChange"
              />
              <datalist id="list-division">
                <option
                  v-for="division in divisions"
                  :key="division.id"
                  >{{ division.name }}</option
                >
              </datalist>
            </b-form-group>
          </validation-provider>
          <validation-provider
            name="Department"
            v-slot="{ errors }"
            slim
            class="flex-fill"
          >
            <b-form-group
              label="Department"
              :invalid-feedback="errors[0]"
              label-size="sm"
              label-class="font-weight-bold"
            >
              <b-form-input
                autocapitalize="off"
                autocomplete="off"
                v-model="form.department"
                list="list-department"
                placeholder="Enter department"
                @keydown="onkeydown($event)"
                :class="{ 'is-invalid': errors.length }"
                :disabled="!trigger"
                @change="departmentChange"
              />
              <datalist id="list-department">
                <option
                  v-for="department in departments"
                  :key="department.id"
                  >{{ department.name }}</option
                >
              </datalist>
            </b-form-group>
          </validation-provider>
          <validation-provider
            name="Company"
            :rules="form.is_contractor ? 'required' : ''"
            v-slot="{ errors }"
            slim
            class="flex-fill"
          >
            <b-form-group
              label="Company"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-select
                v-model="form.company_id"
                :options="company"
                value-field="id"
                text-field="name"
                size="sm"
                :class="{ 'is-invalid': errors.length }"
                :disabled="!isEdit && !trigger"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    Please select an option
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </validation-provider>
          <validation-provider
            name="Contractor"
            :rules="form.is_contractor ? 'required' : ''"
            v-slot="{ errors }"
            slim
            class="flex-fill"
          >
            <b-form-group
              label="Contractor"
              label-size="sm"
              label-class="font-weight-bold"
              :hidden="!form.is_contractor"
              :invalid-feedback="errors[0]"
            >
              <b-form-select
                v-model="form.contractor_id"
                :options="contractors"
                value-field="id"
                text-field="name"
                size="sm"
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
          <validation-provider
            name="Email"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill"
          >
            <b-form-group
              label="Email"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-input
                autocapitalize="off"
                autocomplete="off"
                v-model="form.email"
                placeholder="Enter email"
                :class="{ 'is-invalid': errors.length }"
                :disabled="!trigger"
              />
            </b-form-group>
          </validation-provider>
          <b-form-group
            label="Phone Number"
            label-size="sm"
            label-class="font-weight-bold"
          >
            <b-form-input
              autocapitalize="off"
              v-model="form.phone"
              placeholder="Enter phone number"
              :disabled="!trigger"
            />
          </b-form-group>
          <validation-provider
            name="Password"
            :rules="form.is_contractor && !isEdit ? 'required' : ''"
            v-slot="{ errors }"
            slim
            class="flex-fill position-relative"
          >
            <div class="position-relative">
              <b-form-group
                label="Password"
                label-size="sm"
                label-class="font-weight-bold"
                :hidden="!form.is_contractor"
                :invalid-feedback="errors[0]"
              >
                <b-form-input
                  autocapitalize="off"
                  autocomplete="off"
                  v-model="form.password"
                  :type="type"
                  :class="{ 'is-invalid': errors.length }"
                />
              </b-form-group>
              <img
                v-if="form.is_contractor"
                :class="iconStyle(errors.length)"
                src="@/assets/icon-hide-password.png"
                alt="logo"
                width="25"
                height="25"
                @click="switchVisibility"
              />
            </div>
          </validation-provider>
        </validation-observer>
        <div class="d-flex justify-content-end align-items-center mt-5">
          <b-button
            class="btn-reset"
            variant="outline-info"
            @click="close"
          >
            Cancel
          </b-button>
          <b-button class="btn-custom ml-2 " variant="info" @click="submit">
            Submit
          </b-button>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import api from '@/api'

export default {
  mounted() {
    this.fetchRolesApi()
    this.fetchContractors()
    this.fetchDivisions()
    this.error = ''
  },
  components: {},
  computed: {
    state() {
      return this.form.fullname.length >= 4
    },
    invalidFeedback() {
      if (this.form.fullname.length > 0) {
        return 'Enter at least 4 characters.'
      }
      return 'Please enter something.'
    },
    isNewEmployee: {
      get() {
        if (this.isEdit) {
          return false
        } else {
          return true
        }
      }
    },
    contractor_id: {
      get() {
        if (this.form.contractors) {
          return this.form.contractors.id
        } else {
          return this.form.contractor_id
        }
      }
    }
  },
  props: {
    isEdit: {
      types: Boolean,
      default: () => false
    },
    form: {
      types: Object,
      default: () => ({})
    },
    division: {
      types: Object,
      default: () => ({})
    },
    company: {
      types: Array,
      default: () => ([])
    }
  },
  watch: {
    'form.is_contractor'() {
      this.fetchRoles()
    },
    'division.id'(value) {
      if (value) {
        this.fetchDepartments(value)
      }
    }
  },
  methods: {
    switchVisibility() {
      this.type = this.type === 'password' ? 'text' : 'password'
    },
    check: function(e) {
      this.error = ''
      this.form.is_contractor = e
      this.fetchRoles()
    },
    async fetchRolesApi() {
      this.allRoles = await api.roles.active()
      this.roles = Object.values(this.allRoles).filter(role => role.type === 'Owner')
    },
    async fetchRoles() {
      this.roles = Object.values(this.allRoles).filter(role => role.type === (this.form.is_contractor ? 'Contractor' : 'Owner'))
    },
    async fetchDivisions() {
      this.divisions = await api.department.divisions()
    },
    async fetchDepartments(id) {
      this.departments = await api.department.list({
        division_id: id
      })
    },
    async fetchContractors() {
      try {
        this.contractors = await api.contractor.list()
      } catch (error) {}
    },
    async submit() {
      const valid = await this.$refs.form.validate()
      if (!valid) {
        return false
      }
      this.$bvModal.hide('modal-create')
      this.$emit('submit', this.form)
    },
    close() {
      this.$emit('cancel')
      this.error = ''
      this.$bvModal.hide('modal-create')
      if (!this.isEdit) {
        this.resetForm()
      }
    },
    onkeydown(e) {
      this.sizeChangedBy = e.key ? 'input' : 'list'
    },
    async checkUser() {
      try {
        this.error = ''
        if (!this.form.is_contractor) {
          if (this.form.username) {
            const { data } = await api.employee.check(this.form)
            this.options = data
            this.trigger = false
            if (this.options.usersData) {
              this.trigger = true
              this.refreshForm()
            } else {
              this.form.is_contractor = true
              this.trigger = true
              this.error = this.options.error ? this.options.error.message : this.options
              this.resetForm()
            }
          }
        }
      } catch ({ response }) {
        this.trigger = true
        this.error = response.data.error.message
        this.resetForm()
      }
    },
    refreshForm() {
      const data = this.options.usersData
      const companyData = this.options.userCompany ? this.options.userCompany : null
      this.form.fullname = data.fullname_ad
      this.form.department_id = this.options.departmentId
      this.form.department = this.options.departmentId === null ? null : data.department_name_ad
      this.form.division_id = this.options.division ? this.options.division.id : null
      this.form.division_name = this.options.division ? this.options.division.name : null
      this.division.name = this.form.division_name
      this.form.email = data.email_ad
      this.form.phone = data.phone_ad
      this.form.company_id = companyData ? companyData.id : null
      this.form.is_active_directory = true
    },
    resetForm() {
      this.form.fullname = null
      this.form.email = null
      this.form.phone = null
      this.form.role_id = null
      this.form.division_id = null
      this.form.department = null
      this.form.department_id = null
      this.form.password = null
      this.form.is_contractor = false
      this.form.is_active_directory = false
    },
    iconStyle(value) {
      return value ? 'icon-hide' : 'icon-hide-no-error'
    },
    departmentChange(value) {
      this.form.department_id = value ? this.departments.find(d => d.name === value).id : null
    },
    divisionChange(value) {
      this.form.division_id = value ? this.divisions.find(d => d.name === value).id : null
      if (this.form.division_id) {
        this.fetchDepartments(this.form.division_id)
      } else {
        this.departments = []
      }
      this.form.department = null
      this.form.department_id = null
    }
  },
  data() {
    return {
      allRoles: null,
      roles: [],
      departments: [],
      divisions: [],
      type: 'password',
      contractors: null,
      sizeChangedBy: null,
      options: {},
      error: '',
      trigger: true
    }
  }
}
</script>
<style lang="scss" scoped>
.icon-hide {
  position: absolute;
  right: 25px;
  top: 55%;
  transform: translateY(-50%);
  cursor: pointer;
}

.icon-hide-no-error {
  position: absolute;
  right: 7px;
  top: 70%;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>
